export class DocumentRejectionTranslation {

  public name: string;
  public languageCode: string;

}
